import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TextInput from "@/components/inputs/TextInput.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileNumber',
  props: {
    modelValue: {
        default: null,
        required: true,
    },
    error: {
        type: String,
        default: null,
    },
    placeholder: {
        type: String,
        default: "Mobile Number",
    },
},
  setup(__props) {



const numberonly = (e) => {
    e = e ? e : window.event;
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        e.preventDefault();
    } else {
        return true;
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TextInput, {
    add_on_left: true,
    add_on_text: "+63",
    onKeypress: numberonly,
    placeholder: __props.placeholder,
    maxlength: "10",
    value: __props.modelValue,
    error: __props.error
  }, null, 8, ["placeholder", "value", "error"]))
}
}

})